// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 846 ? "Flickity" : chunkId) + "." + {"442":"1b0580c342cd4139a8fe","846":"78f2311f68aed7187936"}[chunkId] + ".js";
};